import { LayingPatternViewer } from 'CommonScripts/layingPatternViewer';

export class Screenshot {
    public static init() {
        const screenshotButtonEl: Element = document.getElementsByClassName('js-screenshot-button')[0];
        screenshotButtonEl?.addEventListener('click', () => {
            Screenshot.take();
        });
    }

    private static take() {
        const audio: HTMLAudioElement = new Audio('asset/sound/camera-snap.mp3');
        audio.play();

        const screenshotEl: HTMLElement = document.getElementsByClassName('js-screenshot-flash')[0] as HTMLElement;
        screenshotEl.classList.remove('snap');
        void screenshotEl.offsetWidth; // Triggers element reflow to restart the snap animation. (https://css-tricks.com/restart-css-animation/)
        screenshotEl.classList.add('snap');

        const currentTexture: any = LayingPatternViewer.getCurrentTexture();
        const frameData: any = LayingPatternViewer.getCurrentFrameData();
        const link: HTMLAnchorElement = document.createElement('a');

        document.body.appendChild(link);
        link.target = '_blank'; // Target must be blank for this to work in Chromium engine
        link.href = frameData.octetImageData;
        link.download = `marshalls__${currentTexture.ProductTextureKey}|pattern_${currentTexture.PatternId}|${(new Date()).toLocaleString().replace(', ', '_')}.jpg`;
        link.click();
        document.body.removeChild(link);
    }
}

Screenshot.init();